import script from "./BackIndexsuspendBall.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackIndexsuspendBall.vue?vue&type=script&lang=ts&setup=true"

import "./BackIndexsuspendBall.vue?vue&type=style&index=0&id=799a8d86&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-799a8d86"]])

export default __exports__